type IconProps = React.SVGProps<SVGSVGElement>;

const LocationDemo: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 17.9067C18.2975 17.9067 20.16 16.0442 20.16 13.7467C20.16 11.4492 18.2975 9.58667 16 9.58667C13.7025 9.58667 11.84 11.4492 11.84 13.7467C11.84 16.0442 13.7025 17.9067 16 17.9067Z"
        stroke="currentColor"
        stroke-width="2"
      />
      <path
        d="M4.8267 11.32C7.45336 -0.226659 24.56 -0.213325 27.1734 11.3333C28.7067 18.1067 24.4934 23.84 20.8 27.3867C18.12 29.9733 13.88 29.9733 11.1867 27.3867C7.5067 23.84 3.29336 18.0933 4.8267 11.32Z"
        stroke="currentColor"
        stroke-width="2"
      />
    </svg>
  );
};

export default LocationDemo;
